import { lazy } from 'react';

const BlogListPage = lazy(() => import('./page.js').then((module) => ({ default: module.BlogListPage })));

export { BlogListPage };
